<template>
	<div class="container">
		<Item :width="528" :height="640" :title="'经营指标'">
			<div class="dataitem_container"
				style="display: flex;flex-direction: row;flex-wrap: wrap;justify-content: space-between;">
				<DataItem :title="'当日用电量'" :data="3423" :unit="'kWh'" />
				<DataItem :title="'累计用电量'" :data="105536" :unit="'kWh'" />
				<DataItem :title="'电池当日充电量'" :data="157" :unit="'kWp'" />
				<DataItem :title="'电池累计充电量'" :data="36950" :unit="'kWh'" />
				<DataItem :title="'电池当日放电量'" :data="154" :unit="'h'" />
				<DataItem :title="'电池累计放电量'" :data="36241" :unit="'kWh'" />
			</div>
		</Item>
		<Item :width="1064" :height="640" :title="'本月发电储电统计'">
			<div class="dataitem_container"
				style="display: flex;flex-direction:row;flex-wrap:wrap;justify-content:space-between;">
				<div style="width:65%;height:100%">
					<Chart :barData="barData"></Chart>
				</div>
				<div
					style="width:35%;height:100%;display:flex;flex-direction:row;flex-wrap:wrap;justify-content:space-between;">
					<DataItemC :title="'发电量'" :data="17136" :unit="'kWh'" />
					<DataItemC :title="'储电量'" :data="3297" :unit="'kWh'" />
					<DataItemC :title="'充发电量比'" :data="0.19" :unit="'%'" />
				</div>
			</div>
		</Item>
		<Item :width="528" :height="312" :title="'累计环保贡献'">
			<div class="dataitem_container">
				<LineItem :icon="require('../../assets/img/二氧化碳.png')" :title="'减少碳排量CO2'" :data="191424"
					:unit="'kg'" />
				<LineItem :icon="require('../../assets/img/煤.png')" :title="'节约标准煤'" :data="76784" :unit="'kg'" />
				<LineItem :icon="require('../../assets/img/树.png')" :title="'相当于植树'" :data="479" :unit="'棵'" />
			</div>
		</Item>
		<Item :width="1064" :height="312" :title="'电池监测'">
			<div class="dataitem_container">
				<Battery />
			</div>
		</Item>
	</div>
</template>

<script>
	import Item from './item.vue'
	import DataItem from './dataitem.vue'
	import Chart from './Chart.vue'
	import LineItem from './lineitem.vue'
	import CircleItem from './circleitem.vue'
	import DataItemC from './dataitemC.vue'
	import Battery from './battery'
	export default {
		name: "PVMonitor",
		components: {
			Item,
			DataItem,
			Chart,
			LineItem,
			CircleItem,
			DataItemC,
			Battery,
		},
		data() {
			return {
				nameArr: ['发电', '储电'],
				valueArr: [17136, 3297],
				colorArr: ['#E0E5EC', '#0D94FF']
			}
		},
		methods: {
			test(percentage) {
				return '当前功率'
			}
		},
		computed: {
			barData: function () {
				return this.nameArr.map((item, index) => {
					return {
						name: this.nameArr[index],
						value: this.valueArr[index],
						itemStyle: {
							color: this.colorArr[index]
						}
					}
				})
			},
		}
	}
</script>

<style lang="less" scoped>
	.container {
		.w(1700);
		.h(976);
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;

		.dataitem_container {
			width: 100%;
			height: 100%;
		}
	}
</style>